// Enums-as-const (§17.1). `isolatedModules` forbids `const enum`, so every id set is an
// `as const` object plus a same-named union type. Frozen after WP0: append-only.

export const MapId = { LOBBY: 0, PODIUM: 1, TEACUP: 2, PINBALL: 3, CAKE: 4, SPIN: 5 } as const;
export type MapId = (typeof MapId)[keyof typeof MapId];
export const ARENAS: readonly MapId[] = [2, 3, 4, 5];

export const ModeId = { LOBBY: 0, PODIUM: 1, ROYALE: 2, HOT_POTATO: 3, CROWN_GRAB: 4 } as const;
export type ModeId = (typeof ModeId)[keyof typeof ModeId];

export const ItemKind = { NONE: 0, BANANA: 1, BOMB: 2, GLOVE: 3, BALLOON: 4, PLUNGER: 5, SHAKE: 6 } as const;
export type ItemKind = (typeof ItemKind)[keyof typeof ItemKind];

export const MutatorId = { NONE: 0, BUTTER_FLOOR: 1, FLOATY: 2, BOMB_PARTY: 3, DOUBLE_DIZZY: 4 } as const;
export type MutatorId = (typeof MutatorId)[keyof typeof MutatorId];

/** Bean state */
export const BS = {
  NORMAL: 0, LUNGE: 1, TUMBLE: 2, GRAB_START: 3, GRAB_MISS: 4, CARRYING: 5, GRABBED: 6,
  TEETER: 7, LEDGE: 8, CLIMB: 9, SLIP: 10, SPUN: 11, YANKED: 12, PUNCH_WINDUP: 13, PUNCH: 14,
  FLOAT: 15, FALLING: 16, GHOST: 17, RESPAWN: 18, FROZEN: 19,
} as const;
export type BS = (typeof BS)[keyof typeof BS];

/** Entity kinds */
export const EK = { CRATE: 1, PEEL: 2, BOMB: 3, PLUNGER: 4, PEBBLE: 5, CROWN: 6, CUBE: 7, DUMMY: 8 } as const;
export type EK = (typeof EK)[keyof typeof EK];

export const Cause = {
  NONE: 0, SHOVE: 1, THROW: 2, GLOVE: 3, BOMB: 4, PEEL: 5, PLUNGER: 6, STOMP: 7, PEBBLE: 8,
  BUMPER: 9, FLIPPER: 10, PINBALL: 11, SWEEPER: 12, FLAME: 13, CUP: 14, POTATO: 15, BODY: 16,
  BUBBLE: 17, CRATE: 18, CLASH: 19, SLINGSHOT: 20,
} as const;
export type Cause = (typeof Cause)[keyof typeof Cause];

export const RoundPhase = { INTRO: 0, CALM: 1, RAMP: 2, SUDDEN_DEATH: 3, OVER: 4 } as const;
export type RoundPhase = (typeof RoundPhase)[keyof typeof RoundPhase];

export const Difficulty = { CHILL: 0, NORMAL: 1, SPICY: 2 } as const;
export type Difficulty = (typeof Difficulty)[keyof typeof Difficulty];

export const Personality = { BULLY: 0, OPPORTUNIST: 1, COWARD: 2, CHAOS: 3, TACTICIAN: 4 } as const;
export type Personality = (typeof Personality)[keyof typeof Personality];

export const RoomPhase = { LOBBY: 0, INTRO: 1, PLAY: 2, ROUND_END: 3, INTERMISSION: 4, AWARDS: 5, PODIUM: 6 } as const;
export type RoomPhase = (typeof RoomPhase)[keyof typeof RoomPhase];

export const TileState = { SOLID: 0, CRACKING: 1, FALLING: 2, GONE: 3, REGROW: 4 } as const;
export type TileState = (typeof TileState)[keyof typeof TileState];

export const AwardId = {
  BIG_BONKER: 0, BANANA_BARON: 1, CLUMSIEST: 2, GHOST_MENACE: 3, HONK_LORD: 4, NINE_LIVES: 5,
  FREQUENT_FLYER: 6, OLDEST_PEEL: 7, GRAB_GOBLIN: 8, CROWN_HOGGER: 9,
} as const;
export type AwardId = (typeof AwardId)[keyof typeof AwardId];

/** `Bean.team` values (§17.3): 0 free-for-all, 1 red, 2 blue. */
export const Team = { NONE: 0, RED: 1, BLUE: 2 } as const;
export type Team = (typeof Team)[keyof typeof Team];

/** Causes that never overwrite an existing credited touch (§2.11); they only refresh its tick. */
export const HAZARD_CAUSES: readonly Cause[] = [
  Cause.BUMPER, Cause.FLIPPER, Cause.PINBALL, Cause.SWEEPER, Cause.FLAME, Cause.CUP,
  Cause.BUBBLE, Cause.CRATE, Cause.SLINGSHOT,
];

export function isHazardCause(cause: Cause): boolean {
  return HAZARD_CAUSES.includes(cause);
}
